export const environment = {
  production: false,
  apiUrl: 'https://sisgaa.cs.umss.edu.bo/apiSisGaa/'
};
